(function (window) {
	var locale = (CLIENT_CULTURE ? CLIENT_CULTURE.toLowerCase() : 'de-ch'),
		lang = locale.substr(0, 2);
	window['hyperform'] && hyperform.setLanguage(lang);
	window['moment'] && moment.locale(locale);

    if(lang === 'de'){
        Dropzone.prototype.defaultOptions.dictFileTooBig = "Datei ist zu gross ({{filesize}}MB). Maximale Dateigrösse: {{maxFilesize}}MB.";
    }else{
        Dropzone.prototype.defaultOptions.dictFileTooBig = "Fichier trop volumineux ({{filesize}}MB). Taille maximale du fichier: {{maxFilesize}}MB.";
    }
	
	if (window['jQuery'] && window['moment'] && jQuery.fn.datepicker)
	{
		// Just override english >:)
		Object.assign(jQuery.fn.datepicker.dates['en'], {
			days: moment.weekdays(),
			daysShort: moment.weekdaysShort(),
			daysMin: moment.weekdaysMin(),
			months: moment.months(),
			monthsShort: moment.monthsShort(),
			// today: "Today",
			// clear: "Clear",
		});
	}
	
}(window));